import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.7498 3.98697C12.7498 5.04551 11.8917 5.90363 10.8332 5.90363C9.77462 5.90363 8.9165 5.04551 8.9165 3.98697C8.9165 2.92843 9.77462 2.07031 10.8332 2.07031C11.8917 2.07031 12.7498 2.92843 12.7498 3.98697Z",
      stroke: "white",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M5.08333 7.50064C5.08333 8.55918 4.22521 9.4173 3.16667 9.4173C2.10812 9.4173 1.25 8.55918 1.25 7.50064C1.25 6.4421 2.10812 5.58398 3.16667 5.58398C4.22521 5.58398 5.08333 6.4421 5.08333 7.50064Z",
      stroke: "white",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.7498 11.0143C12.7498 12.0729 11.8917 12.931 10.8332 12.931C9.77462 12.931 8.9165 12.0729 8.9165 11.0143C8.9165 9.95577 9.77462 9.09766 10.8332 9.09766C11.8917 9.09766 12.7498 9.95577 12.7498 11.0143Z",
      stroke: "white",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.90967 6.70147L9.06245 4.78516M4.90967 8.29903L9.06245 10.2153",
      stroke: "white",
      "stroke-width": "1.5"
    }, null, -1)
  ]))]))
}
export default { render: render }